// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file shop_config/types/v1/order_confirmation.proto (package shop_config.types.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Text } from "../../../types/v1/text_pb.js";

/**
 * @generated from enum shop_config.types.v1.EstimatedDeliveryTime
 */
export const EstimatedDeliveryTime = /*@__PURE__*/ proto3.makeEnum(
  "shop_config.types.v1.EstimatedDeliveryTime",
  [
    {no: 0, name: "ESTIMATED_DELIVERY_TIME_UNSPECIFIED"},
    {no: 1, name: "ESTIMATED_DELIVERY_TIME_2_DAYS"},
    {no: 2, name: "ESTIMATED_DELIVERY_TIME_5_DAYS"},
    {no: 3, name: "ESTIMATED_DELIVERY_TIME_7_DAYS"},
    {no: 4, name: "ESTIMATED_DELIVERY_TIME_10_DAYS"},
    {no: 5, name: "ESTIMATED_DELIVERY_TIME_14_DAYS"},
    {no: 6, name: "ESTIMATED_DELIVERY_TIME_21_DAYS"},
  ],
);

/**
 * @generated from message shop_config.types.v1.OrderConfirmationTemplateConfig
 */
export const OrderConfirmationTemplateConfig = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.OrderConfirmationTemplateConfig",
  () => [
    { no: 1, name: "email_information", kind: "message", T: Text, opt: true },
    { no: 2, name: "postal_information", kind: "message", T: Text, opt: true },
    { no: 3, name: "estimated_delivery_time", kind: "enum", T: proto3.getEnumType(EstimatedDeliveryTime), opt: true },
    { no: 4, name: "your_visit_information", kind: "message", T: Text, opt: true },
    { no: 5, name: "show_order_confirmation", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message shop_config.types.v1.SaveOrderConfirmationTemplatesRequest
 */
export const SaveOrderConfirmationTemplatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.SaveOrderConfirmationTemplatesRequest",
  () => [
    { no: 1, name: "order_confirmation_template_config", kind: "message", T: OrderConfirmationTemplateConfig },
  ],
);

/**
 * @generated from message shop_config.types.v1.SaveOrderConfirmationTemplatesResponse
 */
export const SaveOrderConfirmationTemplatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.SaveOrderConfirmationTemplatesResponse",
  () => [
    { no: 1, name: "order_confirmation_template_config", kind: "message", T: OrderConfirmationTemplateConfig },
  ],
);

/**
 * @generated from message shop_config.types.v1.GetOrderConfirmationTemplatesRequest
 */
export const GetOrderConfirmationTemplatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.GetOrderConfirmationTemplatesRequest",
  [],
);

/**
 * @generated from message shop_config.types.v1.GetOrderConfirmationTemplatesResponse
 */
export const GetOrderConfirmationTemplatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.GetOrderConfirmationTemplatesResponse",
  () => [
    { no: 1, name: "order_confirmation_template_config", kind: "message", T: OrderConfirmationTemplateConfig },
  ],
);

